import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import {
  AcceptChangeSchema,
  AcceptData,
  AcceptDataBackend, EcoObjectType,
  EcoVersionType, FilialNodeTree, ImportDiffObject,
  PtnBuisnessPeriondType
} from "./models-service";
import notify_service from "@/services/notify_service";

const route_ns = `ptn_import`;

class PtnImportService {

    data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);


  constructor() {
    //
  }

  public async get(): Promise<IResponseResult<PtnBuisnessPeriondType[]>> {
    const response: AxiosResponse["data"] = await this.crud.get();

    if (response?.data) {
      return {data: response.data as PtnBuisnessPeriondType[] };
    } else {
      return { data: null, message: "" };
    }
  }

  public async get_gen_object_list(year_id: string, cut_id: string, months: number[],
                                   all_filials: boolean, filials: number[],
                                   all_heat_nodes: boolean, heat_nodes: number[]): Promise<IResponseResult<EcoObjectType[]>> {
    try {

      let data = {
        year_id: year_id,
        cut_id: cut_id,
        months: months,
        all_filials: all_filials,
        filials: filials,
        all_heat_nodes: all_heat_nodes,
        heat_nodes: heat_nodes,
      }
      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/gen_object_list`,
        method: 'post',
        data: data
      });

      if (resp) {
        return {data: resp}
      } else {
        return {data: []}
      }
    } catch (e) {

      return { data: null };
    }
  }


  public async verify(filter: any): Promise<IResponseResult<ImportDiffObject[]>> {
    try {

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/verify`,
        method: 'post',
        data: filter,
        timeout: 60000
      });

      if (resp) {
        return {data: resp}
      } else {
        return {data: null}
      }
    } catch (e) {

      return { data: null };
    }
  }

  public async import_data(filter: any): Promise<IResponseResult<ImportDiffObject[]>> {
    try {

      const resp: AxiosResponse["data"] = await request({
        url: `${route_ns}/import`,
        method: 'post',
        data: filter,
        timeout: 60000
      });

      if (resp) {
        return {data: resp}
      } else {
        return {data: []}
      }
    } catch (e) {

      return { data: null };
    }
  }


  empty() {

  }

}

export default new PtnImportService();
